import { render, staticRenderFns } from "./pageContent.vue?vue&type=template&id=74f7c9ca"
import script from "./pageContent.vue?vue&type=script&lang=js"
export * from "./pageContent.vue?vue&type=script&lang=js"
import style0 from "./pageContent.vue?vue&type=style&index=0&id=74f7c9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports